<template>
  <div>
    <Layout />
    <v-container grid-list-md>
      <notifications position="bottom center" />
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar flat color="white" class="elevation-1">
            <v-toolbar-title>Pedidos</v-toolbar-title>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model.lazy="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
              class="hidden-md-and-down"
            ></v-text-field>
            <v-spacer></v-spacer>
            <!-- <v-btn color="primary" dark class="mb-2" @click="openForm({})">Novo</v-btn> -->
          </v-toolbar>

          <v-data-table
            :headers="columns"
            :items="items"
            :loading="loading"
            hide-default-footer
            class="elevation-1"
          >
            <template v-slot:item.action="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="openForm(item)"
                v-if="item.status < 2"
                >edit</v-icon
              >

              <v-icon small @click="deleteItem(item)" v-if="item.status < 2"
                >delete</v-icon
              >
            </template>

            <template v-slot:item.status="{ item }">
              {{ item.status | statusFilter }}
            </template>

            <template v-slot:item.buttons="{ item }">
              <v-btn
                depressed
                color="secondary"
                v-if="item.status == 0"
                @click="ready(item.id)"
              >
                Feito
              </v-btn>
              <v-btn
                depressed
                color="accent"
                v-if="item.status == 1"
                @click="finish(item.id)"
              >
                Entregue</v-btn
              >
            </template>

            <template v-slot:item.print="{ item }">
              <v-btn depressed color="primary" @click="print(item.id)">
                <i class="fas fa-print"></i>
              </v-btn>
            </template>

            <template slot="no-data"
              >Desculpe, nenhum dado para ser exibido!</template
            >
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination
              v-model="pagination.page"
              :length="pages"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>

      <div v-if="FormActive.open">
        <order-form
          :active="FormActive.open"
          :item="FormActive.item"
          :finish="onCloseForm"
        ></order-form>
      </div>
    </v-container>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  data() {
    return {
      search: "",
      pagination: {
        totalItems: 0,
        rowsPerPage: 10,
        ascending: false,
        page: 1,
        sortBy: "id",
      },
      items: [],
      columns: [
        { text: "", value: "print", sortable: false },
        { value: "id", text: "ID" },
        { value: "client.name", text: "Nome" },
        { value: "client.phone", text: "Telefone" },
        { value: "address", text: "Endereço" },
        { value: "status", text: "Status" },
        { text: "", value: "buttons", sortable: false },
        { text: "", value: "action", sortable: false },
      ],
      FormActive: { open: false, item: {} },
      loading: false,
    };
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  watch: {
    "pagination.page": {
      handler() {
        this.getList();
      },
      deep: true,
    },
    search: function () {
      this.debounceInput();
    },
  },
  filters: {
    statusFilter: function (value) {
      switch (value) {
        case 0:
          return "Em aberto";
          break;
        case 1:
          return "Pronto";
          break;
        case 2:
          return "Finalizado";
          break;
        case 3:
          return "Cancelado";
          break;
      }
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getList();
    },
    getList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const params = {
          ...this.pagination,
          totalItems: undefined,
          search: this.search,
        };
        this.$http
          .get(`/orders/list`, { params })
          .then((response) => response.data)
          .then((json) => {
            setTimeout(() => {
              this.loading = false;
              this.items = json.items;
              this.pagination.totalItems = json.total;
            }, 1000);
          })
          .catch(() => (this.loading = false));
      });
    },
    openForm(item) {
      this.FormActive.open = true;
      this.FormActive.item = item;
    },
    onCloseForm() {
      this.FormActive.open = false;
      this.getList();
    },
    deleteItem(item) {
      console.log(item.id);

      if (confirm(`Deseja realmente excluir o pedido ${item.id}?`)) {
        this.$http.delete(`/orders/${item.id}`).then((response) => {
          this.$notify({
            title: `Pedido Excluido!`,
            type: "error",
          });
          this.getList();
        });
      }
    },
    ready(id) {
      this.$http.put(`/orders/ready/${id}`).then((response) => {
        this.$notify({
          title: `Pedido finalizado`,
          type: "success",
        });
        this.getList();
      });
    },
    finish(id) {
      if (confirm(`Deseja realmente finalizar o pedido ${id}?`)) {
        this.$http.put(`/orders/finish/${id}`).then((response) => {
          this.$notify({
            title: `Pedido finalizado`,
            type: "success",
          });
          this.getList();
        });
      }
    },
    print(id) {
      this.$router.replace(`/print/${id}`);
    },
    debounceInput: _.debounce(function () {
      setTimeout(() => {
        this.getList();
      }, 200);
    }, 400),
  },
};
</script>
